/* eslint-disable */
import React, { useState } from 'react';
import styled from 'styled-components';
import WizardContent from '~/layouts/WizardContent';
import ContentHeader from '~/components/ContentHeader';
import { Form, PhoneNumberInput } from '~/components';
import { Button, Input, message, Modal, Select, Typography } from 'antd';
import { useHandbook } from '~/controllers/handbook';
import { useIsMobile } from '~/hooks/useScreenSizes';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useCreateNewSalesLead } from '~/controllers/sales';

import { WarningSvgIcon } from '~/img';
import paths from '~/pages/paths';
import { CloseCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { handleGetutm } from '~/utils/handleGetUtm';
import { useGetApplication } from '~/controllers/wizard';
import { getStagePayload } from '~/utils/getStagePayload';
import { getStageHandler } from '~/utils/getStageHandler';

import { CustomPhoneInput } from '~/components/MobileFormItem';

function ContactUs(props: any) {
  const isMobile = useIsMobile();
  const history = useHistory();
  const applicationQuery: any = useGetApplication();
  const activeStep = getStagePayload.wizard(applicationQuery?.data)?.activeStep;
  const getStage = getStageHandler({
    stepName: activeStep?.key,
    stage: applicationQuery?.data?.stage,
    isInitialInfo: !Object?.keys(applicationQuery?.data?.payload?.thiqahFullInfo || {})?.length,
    isNafath: applicationQuery?.data?.contract?.length,
  });

  const [openHelpModa, setOpenHelpModa] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [errorData, setErrorData] = useState<{ description?: string; arDescription?: string } | null>(null);
  const createLead = useCreateNewSalesLead();
  const { t, i18n } = useTranslation('fillApplication');
  const isArabic = i18n.language?.slice(0, 2) === 'ar';
  const { TextArea } = Input;
  const { data: handbookData } = useHandbook();

  const options = (
    handbookData?.handbooks
      ?.find((h: any) => h.key === 'product')
      ?.values ?? []
  ).map((v: any) => ({
    label: v.localizedValue,
    value: v.apiValue,
  }));

  const handleSubmit = (values: any) => {
    const url = window.location.href;
    const utms = handleGetutm(applicationQuery.data);
    const selectedProducts: string[] = values?.product || [];

    const nameParts = (values?.fullName || '').trim().split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ');

    const finalValues = {
      channel: 'SOB_CONTACT_US_FORM',
      companyName: values?.companyName,
      products: {
        ecom: selectedProducts.includes('ECOM'),
        payLinks: selectedProducts.includes('Pay Links'),
        pos: selectedProducts.includes('POS'),
        other: selectedProducts.includes('Other'),
      },
      comments: values?.comments,
      businessPhone: values?.phoneNumber,
      businessEmail: values?.businessEmail,
      stage: getStage,
      result: 'NOT_HANDLED_YET',
      firstName,
      lastName,
      monthTransactionValue: values?.monthTransactionValue,
      leadStatus: 'ACTIVE',
      newExist: 'New',
      salesRemark: 'Pending assignment',
      url: `${url}?${utms}`,
      adGroupName: 'signup_button',
      referralUrl: '---',
      landingPage: url,
      campaignName: 'onboarding',
      email: values?.businessEmail,
      phoneNumber: values?.phoneNumber,
    };
    void createLead.mutateAsync(finalValues, {
      onError: (error: any) => {
        const apiError = error?.response?.data;
        setErrorData({
          description: apiError?.description || error?.message || 'Something went wrong. Please try again.',
          arDescription: apiError?.arDescription,
        });
        setShowModalError(true);
      },
      onSuccess: () => {
        history?.goBack();
        message.success('Inquiry submitted successfully.');
      },
    });
    return values;
  };

  const validatePersonalPhoneNumber = (value: any) => {
    if (!value) return Promise.resolve();
    if (value.length < 12) return Promise.reject('Please enter a valid phone number');
    return Promise.resolve();
  };

  const validateEmail = (value: any) => {
    if (!value) return Promise.resolve();
    const emailRegEx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegEx.test(value)) return Promise.resolve();
    return Promise.reject('Please enter a valid email address');
  };

  return (
    <WizardContent
      right={<></>}
      left={<></>}
      content={
        <Container isMobile={isMobile}>
          <ContentHeader
            title={t("We're here to help")}
            subtitle={t('Submit your inquiry and our team will get back to you shortly.')}
            hideBackArrow={!isMobile}
          />
          <ContactForm name="contactUsForm" onFinish={(e: any) => handleSubmit(e)} isMobile={isMobile}>
            <Form.Item initialValue="SOB Contact US" hidden name="channel">
              <Input placeholder="e.g., jamesmark@global.net" />
            </Form.Item>
            <Form.Item
              rules={[
                { required: true },
                {
                  pattern: /^[A-Za-z\u0600-\u06FF\s]+$/,
                  message: t('The field must contain only letters'),
                },
              ]}
              name="companyName"
              labelText={t('Company Name')}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item rules={[{ required: true }]} name="product" labelText={t('Product')} className="productSelectWrap">
              <Select
                mode="multiple"
                placeholder={t('Select products')}
                options={options}
                allowClear
              />
            </Form.Item>
            <Form.Item
              rules={[
                { required: true },
                {
                  pattern: /^[A-Za-z\u0600-\u06FF\s]+$/,
                  message: t('The field must contain only letters'),
                },
              ]}
              name="fullName"
              labelText={t('Full Name')}
            >
              <Input placeholder={t('e.g., James Mark')} />
            </Form.Item>
            <Form.Item
              rules={[
                { required: true },
                {
                  validator: (_, value) => validatePersonalPhoneNumber(value),
                  message: t('Please enter a valid phone number'),
                },
              ]}
              name="phoneNumber"
              labelText={t('Business Phone')}
            >
              <CustomPhoneInput />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  validator: (_, value) => validateEmail(value),
                  message: t('Please enter a valid email address'),
                },
              ]}
              name="businessEmail"
              labelText={t('Email Address (Optional)')}
            >
              <Input placeholder={t('e.g., jamesmark@global.net')} />
            </Form.Item>
            <Form.Item
              name="monthTransactionValue"
              labelText={t('Est. Monthly Transaction Value (Optional)')}
            >
              <Input placeholder={t('e.g., 25000,00')} />
            </Form.Item>
            <Form.Item
              name="comments"
              labelText={t('Message (Optional)')}
            >
              <TextArea placeholder={t('Tell us about your inquiry...')} rows={4} />
            </Form.Item>

            {isMobile ? (
              <MobileFooter>
                <MobileSubmitButton
                  type="default"
                  id="WizardContinueButton"
                  htmlType="submit"
                  loading={createLead.isLoading}
                  disabled={createLead.isLoading}
                >
                  {t('Submit')}
                </MobileSubmitButton>
                <MobileHelpButton onClick={() => setOpenHelpModa(true)} type="text">
                  {t('For Immediate Help')}
                </MobileHelpButton>
              </MobileFooter>
            ) : (
              <BtmActions dir="ltr">
                <BackButton
                  onClick={() => history.goBack()}
                  type="default"
                  id="WizardBackButton"
                >
                  {t('Back')}
                </BackButton>
                <BtmActionsRight>
                  <HelpTextButton onClick={() => setOpenHelpModa(true)} type="text">
                    {t('For immediate help')}
                  </HelpTextButton>
                  <SubmitButton
                    type="default"
                    id="WizardContinueButton"
                    htmlType="submit"
                    loading={createLead.isLoading}
                    disabled={createLead.isLoading}
                  >
                    {t('Submit')}
                  </SubmitButton>
                </BtmActionsRight>
              </BtmActions>
            )}
          </ContactForm>

          {/* Error Modal */}
          <Modal
            centered
            visible={showModalError}
            footer={null}
            onCancel={() => setShowModalError(false)}
          >
            <ErrorModalBody>
              <ErrorIconWrapper>
                <ErrorIcon />
              </ErrorIconWrapper>
              <ErrorMessage>
                {isArabic && errorData?.arDescription
                  ? errorData.arDescription
                  : errorData?.description || t('Please Try Again')}
              </ErrorMessage>
              <ErrorSubMessage>
                {t('Please Try Again')}
              </ErrorSubMessage>
              <RetryButton type="primary" onClick={() => window.location.reload()}>
                {t('Retry')}
              </RetryButton>
            </ErrorModalBody>
          </Modal>

          {/* Help Modal */}
          <StyledHelpModal
            centered
            width={800}
            visible={openHelpModa}
            footer={null}
            closable={false}
            onCancel={() => setOpenHelpModa(false)}
          >
            <HelpModalContent dir={isArabic ? 'rtl' : 'ltr'}>
              <HelpModalHeader>
                <HelpModalTitle isArabic={isArabic}>
                  {t('Contact the Network International Customer Services team directly')}
                </HelpModalTitle>
                <HelpModalClose onClick={() => setOpenHelpModa(false)} />
              </HelpModalHeader>

              <HelpModalSection isArabic={isArabic}>
                <HelpModalSectionTitle level={5}>
                  {t('Operating Hours')}
                </HelpModalSectionTitle>
                <HelpModalSectionText>
                  {t('Sunday - Thursday: 8 AM - 4 PM')}
                </HelpModalSectionText>
              </HelpModalSection>

              <HelpModalBodyText isArabic={isArabic}>
                {t('For immediate help, call our Customer Services phone number below.')}
              </HelpModalBodyText>

              <HelpModalFooter>
                <CallSupportButton
                  onClick={() => { window.location.href = 'tel:920017697'; }}
                  type="default"
                >
                  {t('Call Support (920017697)')}
                </CallSupportButton>
              </HelpModalFooter>
            </HelpModalContent>
          </StyledHelpModal>
        </Container>
      }
    />
  );
}

/* ─── Styled Components ───────────────────────────────────────────────────── */

const Container = styled.div<{ isMobile?: boolean }>`
  width: 100%;

  .ant-input:not(textarea) {
    height: 58px !important;
    border-radius: 8px !important;
    padding: 16px 12px !important;
    font-size: 14px !important;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 58px !important;
    border-radius: 8px !important;
    padding: 0 12px !important;
    display: flex !important;
    align-items: center !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-search-input {
    height: 58px !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 58px !important;
    display: flex !important;
    align-items: center !important;
  }
  .productSelectWrap .ant-select-selection-item {
    line-height: 30px !important;
  }
  .productSelectWrap .ant-select-lg .ant-select-selector{
    height:56px !important;
  }
`;

const ContactForm = styled(Form) <{ isMobile?: boolean }>`
  padding-bottom: ${({ isMobile }) => (isMobile ? '80px' : '0')};

  @media (min-width: 577px) {
    .ant-form-item {
      max-width: 60%;
    }
  }
`;

/* Bottom action bar */
const BtmActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
`;

const BtmActionsRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const BackButton = styled(Button)`
  width: 140px !important;
  height: 44px !important;
  border-radius: 8px !important;
  background: #f5f9fc !important;
  color: #0069b1 !important;
  border-color: #c2dbec !important;
`;

const HelpTextButton = styled(Button)`
  color: #0069b1 !important;
  font-family: Inter, sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 0 !important;
`;

const SubmitButton = styled(Button)`
  width: 140px !important;
  height: 44px !important;
  border-radius: 8px !important;
  background: #0069b1 !important;
  border-color: #0069b1 !important;
  color: #fff !important;
`;

/* Mobile footer */
const MobileFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: #fff;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 -1px 0 0 #e8f1f7, 0 -6px 8px -2px rgba(0, 89, 150, 0.03);
`;

const MobileSubmitButton = styled(Button)`
  width: 100% !important;
  height: 48px !important;
  background: #0069b1 !important;
  color: #fff !important;
  border-radius: 8px !important;
  border: none !important;
`;

const MobileHelpButton = styled(Button)`
  width: 100% !important;
  color: #0069b1 !important;
  font-family: Inter, sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 0 !important;
  text-align: center !important;
`;

/* Error modal */
const ErrorModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  margin-top: 80px;
  margin-bottom: 80px;
`;

const ErrorIconWrapper = styled.div`
  border-radius: 200px;
  background: #fceaee;
  color: #fff;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
`;

const ErrorIcon = styled(WarningSvgIcon)`
  font-size: 40px;
  color: transparent;
  background: transparent;
  padding-top: 19px;
`;

const ErrorMessage = styled(Typography.Paragraph)`
  font-size: 20px !important;
  font-weight: 500 !important;
  margin-bottom: 4px !important;
`;

const ErrorSubMessage = styled(Typography.Paragraph)`
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #8f8f8f !important;
`;

const RetryButton = styled(Button)`
  width: 150px !important;
  font-weight: 600 !important;
`;

/* Help modal */
const StyledHelpModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px !important;
    padding: 40px !important;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08) !important;
  }
  .ant-modal-body {
    padding: 0 !important;
  }
`;

const HelpModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const HelpModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

const HelpModalTitle = styled(Typography.Title) <{ isArabic?: boolean }>`
  && {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #000;
    line-height: 28px;
    max-width: 680px;
    text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
  }
`;

const HelpModalClose = styled(CloseOutlined)`
  font-size: 20px;
  color: #1c2027;
  cursor: pointer;
  padding-top: 4px;
`;

const HelpModalSection = styled.div<{ isArabic?: boolean }>`
  text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
`;

const HelpModalSectionTitle = styled(Typography.Title)`
  && {
    font-size: 14px;
    font-weight: 600;
    color: #000;
    margin-bottom: 6px;
  }
`;

const HelpModalSectionText = styled(Typography.Paragraph)`
  && {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin: 0;
  }
`;

const HelpModalBodyText = styled(Typography.Paragraph) <{ isArabic?: boolean }>`
  && {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin: 0;
    text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
  }
`;

const HelpModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const CallSupportButton = styled(Button)`
  font-weight: 500 !important;
  color: #0069b1 !important;
  background: #f5f9fc !important;
  border-color: #c2dbec !important;
  border-radius: 8px !important;
  height: 44px !important;
  padding: 0 24px !important;
  font-size: 14px !important;
`;

export default ContactUs;
